import MainModel from "../../../components/Models/main-model";
import {
  Box,
  Flex,
  FormLabel,
  Heading,
  Stack,
  Textarea,
  Button,
  VStack,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeAdminHomeworkCommentModel } from "../../../modules/admin-modules/models/Actions";
import { useState, useEffect } from "react";
import { commentStuentHomeworkRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";
import Select from "react-select";
const HomeworkComment = ({ data, homeworkId }) => {
  const openHomeworkComment = useSelector((state) => state.model.isOpen27);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const assistants = useSelector((state) => state.teacherassistants.assistants);
  const [assistant, setAssistant] = useState("");
  const [assistantComment, setAssistantComment] = useState("");
  const assistantsOptions = assistants?.data?.map((data) => {
    return { value: data.id, label: data.name, sign: data.school };
  });
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  useEffect(() => {
    dispatch(getAssistantsRequest());
  }, []);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px"></Heading>
    </Box>
  );
  const handelAddComment = () => {
    dispatch(
      commentStuentHomeworkRequest({
        id: data?.id,
        body: {
          homework_id: homeworkId,
          student_id: data?.student?.id,
          evaluation: comment,
          assistant_id: assistant,
          assistant_comment: assistantComment,
        },
      })
    );
    dispatch(closeAdminHomeworkCommentModel());
  };
  const closeFunc = () => {
    dispatch(closeAdminHomeworkCommentModel());
    setComment("");
    setAssistant("");
    setAssistantComment("");
  };

  return (
    <MainModel
      isLoading={false}
      header={header}
      closeFunc={closeFunc}
      openVar={openHomeworkComment}
      buttonTitle={"حفظ التغيرات"}
      buttonFunc={handelAddComment}
    >
      <VStack dir="rtl">
        <Button
          as="a"
          href={`https://api.edutopiaonline.com/public/homework/${data?.file}`}
          target="_blank"
        >
          الحل
        </Button>

        <Box w="100%">
          <FormLabel> التصحيح : </FormLabel>
          <Textarea
            id="comment"
            bg="#f5f5f5"
            placeholder="اكتب الملاحظات"
            onChange={(e) => setComment(e.target.value)}
            name="homework"
          ></Textarea>
        </Box>

        <Box w="100%">
          <FormLabel> اختر المساعد : </FormLabel>
          <Select
            styles={colourStyles}
            options={assistantsOptions}
            onChange={(e) => {
              setAssistant(e.value);
              document.getElementById("comment").value += "\n\n" + e.sign;
              setComment(document.getElementById("comment").value);
            }}
            placeholder="اختر المساعد"
          />
        </Box>

        <Box w="100%">
          <FormLabel> ملاحظات المساعد : </FormLabel>
          <Textarea
            id="assistantComment"
            bg="#f5f5f5"
            placeholder="اكتب الملاحظات"
            onChange={(e) => setAssistantComment(e.target.value)}
            name="homework"
          ></Textarea>
        </Box>
      </VStack>
    </MainModel>
  );
};

export default HomeworkComment;
